import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { Box, Grid, Typography, Dialog as MuiDialog, DialogTitle, IconButton, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Close as CloseIcon } from '@material-ui/icons';
import { Logger, ModuleTypeEnum, PluginManager, getIcon } from '@kailona/core';
import { KailonaButton } from '@kailona/ui';
import ImportDataBrowser from './ImportDataBrowser';
import { withNotification } from '../../context/NotificationContext';
import { importJSON } from '../../lib/importFHIRData';
import './ImportDataModal.styl';
var logger = new Logger('main.ImportDataModal');
var DEFAULT_PLUGINS = ['plugin-documents'];
var Dialog = withStyles({
  paper: {
    position: 'absolute',
    top: '10%',
    bottom: '10%'
  }
})(function (props) {
  return /*#__PURE__*/React.createElement(MuiDialog, props);
});

var styles = function styles(theme) {
  return {
    importIcon: {
      textAlign: 'center',
      color: theme.palette.primary.dark
    }
  };
};

var ImportDataModal = /*#__PURE__*/function (_Component) {
  _inherits(ImportDataModal, _Component);

  var _super = _createSuper(ImportDataModal);

  function ImportDataModal(props) {
    var _this;

    _classCallCheck(this, ImportDataModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onFileDrop", function (newFiles) {
      var files = _this.state.files; // Prevent duplicates

      newFiles.forEach(function (newFile) {
        if (files.some(function (f) {
          return f.file.name === newFile.name && f.file.path === newFile.path;
        })) {
          return;
        }

        files.push({
          file: newFile,
          pluginIds: DEFAULT_PLUGINS
        });
      });

      _this.setState({
        files: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFileRemove", function (file) {
      var files = _this.state.files;
      var indexToDelete = files.findIndex(function (f) {
        return f.file.name === file.name && f.file.path === file.path;
      });

      if (indexToDelete < 0) {
        return;
      }

      files.splice(indexToDelete, 1);

      _this.setState({
        files: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDataTypesChanged", function (file, pluginIds) {
      var files = _this.state.files;
      var fileData = files.find(function (f) {
        return f.file.name === file.name && f.file.path === file.path;
      });
      fileData.pluginIds = pluginIds;

      _this.setState({
        files: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "browseFiles", function () {
      if (!_this.dropzoneRef.current) {
        return;
      }

      _this.dropzoneRef.current.open();
    });

    _defineProperty(_assertThisInitialized(_this), "importFiles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var files, promises;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              files = _this.state.files;

              _this.setState({
                importing: true
              });

              promises = []; // Import files to selected plugins

              files.forEach(function (fileData) {
                var file = fileData.file,
                    pluginIds = fileData.pluginIds;
                PluginManager.plugins.forEach(function (plugin) {
                  var id = plugin.id,
                      modules = plugin.modules; // Skip if plugin is not selected

                  if (!pluginIds.includes(id)) {
                    return;
                  } // Skip if plugin does not support data import


                  var dataModule = modules[ModuleTypeEnum.DataModule];

                  if (!dataModule || typeof dataModule.importData !== 'function') {
                    return;
                  }

                  var promise = dataModule.importData(file);
                  promises.push(promise);
                });

                if (pluginIds.includes('FHIR') && file.type === 'application/json') {
                  var promise = importJSON(file);
                  promises.push(promise);
                }
              }); // Wait for all files to be imported

              _context.next = 7;
              return Promise.all(promises);

            case 7:
              _this.setState({
                importing: false,
                files: []
              });

              _this.props.onClose(); // Give notification


              _this.props.showNotification({
                severity: 'success',
                message: t('ehr', 'Data has been successfully imported')
              });

              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              logger.error('Failed to import data', _context.t0);

              _this.setState({
                importing: false
              }); // Give notification


              _this.props.showNotification({
                severity: 'error',
                message: t('ehr', 'An error occurred while importing data. Please contact your administrator.')
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    })));

    _this.dropzoneRef = /*#__PURE__*/React.createRef();
    _this.state = {
      importing: false,
      files: []
    };
    return _this;
  }

  _createClass(ImportDataModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          importing = _this$state.importing,
          files = _this$state.files;
      var importIcon = getIcon('CloudUploadOutlined');
      var browseFilesButtonTitle = t('ehr', files && files.length ? 'Add More Files' : 'Browse Files');
      return /*#__PURE__*/React.createElement(Dialog, {
        maxWidth: "sm",
        fullWidth: true,
        open: this.props.isOpen
      }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        flexGrow: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h3"
      }, t('ehr', 'Import Data'))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.props.onClose
      }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement("div", {
        className: "dropzone-container"
      }, /*#__PURE__*/React.createElement(Dropzone, {
        ref: this.dropzoneRef,
        className: "dropzone-element",
        onDrop: this.onFileDrop
      }, function (_ref2) {
        var getRootProps = _ref2.getRootProps,
            getInputProps = _ref2.getInputProps;
        return files.length ? /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement("input", getInputProps())) : /*#__PURE__*/React.createElement("section", {
          className: "dropzone-section"
        }, /*#__PURE__*/React.createElement("div", _extends({
          className: "dropzone-dragarea"
        }, getRootProps()), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement("div", {
          className: "subtitle"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
          variant: "h2",
          style: {
            fontWeight: 'normal'
          }
        }, t('ehr', 'Drag and Drop Files'))), /*#__PURE__*/React.createElement("div", {
          className: _this2.props.classes.importIcon
        }, importIcon))));
      }), files && !!files.length && /*#__PURE__*/React.createElement(ImportDataBrowser, {
        files: files,
        onDataTypesChanged: this.onDataTypesChanged,
        onFileRemove: this.onFileRemove
      }), /*#__PURE__*/React.createElement(Box, {
        m: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        justify: "center",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(KailonaButton, {
        variant: "outlined",
        class: "primary",
        title: browseFilesButtonTitle,
        disabled: importing,
        onClick: this.browseFiles
      })), files && !!files.length && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(KailonaButton, {
        variant: "outlined",
        class: "primary",
        title: "Import",
        disabled: importing,
        onClick: this.importFiles
      })), importing && /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        color: "primary",
        size: 20
      }))))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ImportDataModal;
}(Component);

_defineProperty(ImportDataModal, "propTypes", {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
});

var _default = withStyles(styles)(withNotification(ImportDataModal));

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataModal.js");
  reactHotLoader.register(DEFAULT_PLUGINS, "DEFAULT_PLUGINS", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataModal.js");
  reactHotLoader.register(Dialog, "Dialog", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataModal.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataModal.js");
  reactHotLoader.register(ImportDataModal, "ImportDataModal", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataModal.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ImportData/ImportDataModal.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();